import EventBus from './Event';
import { presGetFields, presSaveFields } from './api_client/api_prescreening.js';
import { preqSaveFields, preqGetFields } from "./api_client/api_prequalification";
import { onPhoneValueChange, validators, onMoneyValueChange } from './utils/utils-form.js';

class ProfileEdit {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$trigger = this.$el.find('[data-edit-trigger]');
    this.$save = this.$el.find('[data-edit-save]');
    // this.$info = this.$el.find('[data-edit-info]');
    // this.$infoItems = this.$el.find('[data-edit-item]');
    // this.$editForm = this.$el.find('[data-edit-form]');
    this.$aboutSection = this.$el.find('[data-profile-section="about"]');
    this.$aboutItems = this.$aboutSection.find('[data-edit-item');
    this.$aboutForm = this.$aboutSection.find('[data-name="profile_about_form"]');
    this.$aboutInputs = this.$aboutForm.find('input, select, textarea');
    this.$aboutEmpty = this.$aboutSection.find('[profile-edit-empty]');
    
    this.$goalsSection = this.$el.find('[data-profile-section="goals"]');
    this.$goalsItems = this.$goalsSection.find('[data-edit-item');
    this.$goalsForm = this.$goalsSection.find('[data-name="profile_goals_form"]');
    this.$goalsInputs = this.$goalsForm.find('input, select, textarea');
    this.$goalsEmpty = this.$goalsSection.find('[profile-edit-empty]');

    this.disabledFields = [
      'profile_about_email',
      'profile_about_first_name',
      'profile_about_last_name',
      'profile_about_birth_date',
      'profile_about_password',
    ];

    this.aboutFieldsMap = {
      'profile_about_first_name': 'preq_legal_first_name',
      'profile_about_last_name': 'preq_legal_last_name',
      'profile_about_email': 'preq_email',
      'profile_about_phone': 'preq_phone_number',
      'profile_about_birth_date': 'preq_date_of_birth'
    };
    this.goalsFieldsMap = {
      'profile_goals_metro_area': 'pres_metro_area',
      'profile_goals_score_range': 'pres_credit_score_range',
      'profile_goals_move_date': 'pres_earliest_move_date',
      'profile_goals_budget': 'pres_monthly_housing_budget',
    };

    this.moneyFieldsSelectors = [
      '[name="profile_goals_budget"]',
    ];
    this.$goalsInputs.filter(this.moneyFieldsSelectors.join(', ')).attr('type', 'text');

    this.editMode = false;
    this.isSaving = false;

    this.onClickTrigger = this.onClickTrigger.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    this.$trigger.on('click', this.onClickTrigger);
    this.$save.on('click', this.onClickSave);

    this.$el.on('input', 'input[type="tel"]', (e) => onPhoneValueChange($(e.target)));
    this.$el.on('blur', this.moneyFieldsSelectors.join(', '), this.onBlurMoneyField.bind(this));
    this.$el.on('focus', this.moneyFieldsSelectors.join(', '), this.onFocusMoneyField.bind(this));
    
    EventBus.on('user:loaded', this.onUserLoaded.bind(this));
  }

  onUserLoaded() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    this.getAboutData();
    this.getGoalsData();

    // @TODO update fields with user data
  }

  async getAboutData() {
    const user = window.grapp.user;

    const preqFieldsRequest = await preqGetFields(user.auth.email);
    if (preqFieldsRequest.fields) {
      const preqFields = preqFieldsRequest.fields;
      this.$aboutInputs.each((i, input) => {
        const $input = $(input);
        const name = $input.attr('name');
        const fieldName = this.aboutFieldsMap[name];
        const $item = this.$aboutItems.filter(`[data-edit-item="${name}"]`);
        
        if (preqFields[fieldName]) {
          $input.val(preqFields[fieldName]);
        }
        if ($item.length) {
          $item.text(preqFields[fieldName]);
        }
      });

      // set email field value to current user email
      this.$aboutForm.find('[name="profile_about_email"]').val(user.auth.email);
      // set email item text to current user email
      const $emailItem = this.$aboutItems.filter('[data-edit-item="profile_about_email"]');
      if ($emailItem.length) {
        $emailItem.text(user.auth.email);
      }
      // set full name item text to current user full name
      const $fullNameItem = this.$aboutItems.filter('[data-edit-item="profile_about_full_name"]');
      if ($fullNameItem.length) {
        $fullNameItem
          .text(`${preqFields.preq_legal_first_name} ${preqFields.preq_legal_last_name}`);
      }
    } else {
      console.log('No prequalification fields found: ', preqFieldsRequest);
      this.$aboutEmpty.show();
      this.$aboutSection.find('[data-edit-trigger]').hide();
      this.$aboutSection.find('[data-edit-info=""]').hide();
      // EventBus.emit('toast', {type: 'error', message: 'No About data found for you user.'});
    }

    // disable fields that should not be edited
    this.$aboutInputs.each((i, input) => {
      const $input = $(input);
      if (this.disabledFields.includes($input.attr('name'))) {
        $input.attr('disabled', 'disabled');
      }
    });
  }

  async getGoalsData() {
    const user = window.grapp.user;

    const presFieldsRequest = await presGetFields(user.auth.email);
    if (presFieldsRequest.fields) {
      const presFields = presFieldsRequest.fields;
      this.$goalsInputs.each((i, input) => {
        const $input = $(input);
        const name = $input.attr('name');
        const fieldName = this.goalsFieldsMap[name];
        const $item = this.$goalsItems.filter(`[data-edit-item="${name}"]`);

        if (presFields[fieldName]) {
          $input.val(presFields[fieldName]);
        }
        if ($item.length) {
          $item.text(presFields[fieldName]);
        }
      });
    } else {
      console.log('No prescreening fields found: ', presFieldsRequest);
      this.$goalsEmpty.show();
      this.$goalsSection.find('[data-edit-trigger]').hide();
      this.$goalsSection.find('[data-edit-info=""]').hide();
      // EventBus.emit('toast', {type: 'error', message: 'No Goals data found for you user.'});
    }
  }

  onClickTrigger(e) {
    e.preventDefault();

    const $target = $(e.currentTarget);
    const sectionName = $target.data('edit-trigger');
    const $section = this.$el.find(`[data-profile-section="${sectionName}"]`);

    this.editMode = $section.hasClass('edit_mode');
    if ($section.hasClass('edit_mode')) {
      this.disableEditMode($section);
    } else {
      this.enableEditMode($section);
    }
  }

  enableEditMode($section) {
    $section.addClass('edit_mode');
    $section.find('[data-edit-trigger]').text('Cancel');
    // this.editMode = true;
  }

  disableEditMode($section) {
    $section.removeClass('edit_mode');
    $section.find('[data-edit-trigger]').text('Edit');
    // this.editMode = false;
  }

  onClickSave(e) {
    e.preventDefault();
    this.isSaving = true;
    // @TODO save data
    console.log('saving...');
    this.isSaving = false;
    this.disableEditMode();
  }

  onBlurMoneyField(e) {
    const $input = $(e.target);
    $input.attr('type', 'text');
    onMoneyValueChange($(e.target));

    // this.updateInputsState($input.attr('name'), $input.val());
  }
  onFocusMoneyField(e) {
    const $input = $(e.target);
    if ($input.val()) {
      $input.val($input.val().replace(/\D/g, ''));
    }
    $input.attr('type', 'number');

    // this.updateInputsState($input.attr('name'), $input.val());
  }
  onBlurNumberField(e) {
    const $input = $(e.target);
    $input.attr('type', 'text');
    onMoneyValueChange($input);
    $input.val($input.val().replace('$', ''));

    // this.updateInputsState($input.attr('name'), $input.val());
  }
  onFocusNumberField(e) {
    const $input = $(e.target);
    if ($input.val()) {
      $input.val($input.val().replace(/\D/g, ''));
    }
    $input.attr('type', 'number');

    // this.updateInputsState($input.attr('name'), $input.val());
  }

  static init() {
    $('[data-js-component="profile-edit"]').each((i, el) => new ProfileEdit(el));
  }
}

ProfileEdit.init();
